import React from 'react';
import ClinicServicesCard from './ClinicServicesCard';
import VerificationCard from './VerificationCard';

function SettingsTab() {
    return (
        <div className="row g-3">
            <ClinicServicesCard />
            <VerificationCard />
        </div>
    );
}

export default SettingsTab;